import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">专题合集</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col gap-2 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50/50 transition-colors border border-background-200/70 cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-lg text-primary-600`}></i>
                </div>
                <span className="text-xs font-bold text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-800 group-hover:text-primary-600 transition-colors leading-snug">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}